import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { apiClient } from '@/api/client';
import { API_INDIVIDUAL_SUPPORT_PLANS_ACKNOWLEDGE } from '@/api/endpoints';
import { ErrorMessage, logRequestError } from '@/utils/errors';

interface Params {
  onSuccess: () => void;
  onFailure: () => void;
}

export const useIndividualSupportPlan = ({ onSuccess, onFailure }: Params) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const { mutate } = useMutation({
    mutationFn: () => apiClient.post(API_INDIVIDUAL_SUPPORT_PLANS_ACKNOWLEDGE),
    onSuccess,
    onError: (error) => {
      logRequestError(ErrorMessage.AcknowledgeIndividualSupportPlan, error);
      onFailure();
    },
  });

  const confirmPlan = () => {
    setIsConfirmOpen(false);
    mutate();
  };

  return {
    isConfirmOpen,
    openConfirm: () => setIsConfirmOpen(true),
    closeConfirm: () => setIsConfirmOpen(false),
    confirmPlan,
  };
};
